var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PaginationController", {
        ref: "getAppleOrders",
        attrs: {
          getDataActionName: "getAppleOrders",
          historyLimit: _vm.historyLimit,
          actionPredicates: _vm.predicates,
          haveSearchBox: true,
          searchBoxLabel: _vm.$t("orderId") + " / Product Name / Tracking",
          searchBoxHint: _vm.$t("orderSearch"),
          isRefreshSelect: false,
          haveStartDate: true,
          keepKeywordCase: ""
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function(ref) {
              var isLoadedToEnd = ref.isLoadedToEnd
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    search: _vm.filter,
                    items: _vm.orders,
                    pagination: _vm.pagination
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c(
                              "tr",
                              {
                                class: props.item.abnormalOrg
                                  ? "abnormal_list"
                                  : ""
                              },
                              [
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.index + 1))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { linkify: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.jump(props.item.url)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.orderId))]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.item.tracking || "-") +
                                      "\n          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-left" },
                                  _vm._l(props.item.orderItems, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "v-flex",
                                      {
                                        key: index + item.productName,
                                        attrs: { row: "" }
                                      },
                                      [
                                        _c("ProductWidget", {
                                          attrs: {
                                            name: item.productName,
                                            quantityShipped: item.quantity
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-left" },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c("v-flex", [
                                          _vm._v(
                                            _vm._s(_vm.$t(props.item.status))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("v-flex", [
                                          _vm._v(
                                            _vm._s(props.item.deliveryDate)
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      props.item.createTime &&
                                        _vm.toTimestampString(
                                          props.item.createTime
                                        )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getOrgId(props.item.organizationKey)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(props.item.processStatus) +
                                      "\n          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-center" },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-center": "",
                                          "no-wrap": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              flat: "",
                                              dark: "",
                                              color: "primary",
                                              loading: props.item.loading
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteOrder(
                                                  props.item,
                                                  props.index
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            }
          },
          {
            key: "beforeSearchBox",
            fn: function() {
              return [
                _vm.isWarehouse
                  ? _c(
                      "v-flex",
                      { attrs: { md4: "", "mr-1": "" } },
                      [
                        _c("SelectWidget", {
                          attrs: {
                            label: _vm.$t("selectOrganization"),
                            items: _vm.organizations,
                            chipText: "organizationId",
                            itemText: "organizationId",
                            itemValue: "key"
                          },
                          model: {
                            value: _vm.selectedOrganization,
                            callback: function($$v) {
                              _vm.selectedOrganization = $$v
                            },
                            expression: "selectedOrganization"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md4: "" } },
                  [
                    _c("v-select", {
                      attrs: {
                        label: _vm.$t("selectStatus"),
                        items: _vm.orderStatusList,
                        chipText: "displayName",
                        itemText: "displayName",
                        itemValue: "key"
                      },
                      model: {
                        value: _vm.selectedStatus,
                        callback: function($$v) {
                          _vm.selectedStatus = $$v
                        },
                        expression: "selectedStatus"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "afterDate",
            fn: function() {
              return [
                _c(
                  "v-flex",
                  { attrs: { md4: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          small: "",
                          color: "primary",
                          disabled: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            _vm.isShowDownloadDialog = true
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("download")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md4: "" } },
                  [
                    _vm.isWarehouse
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              small: "",
                              color: "primary",
                              title: "importFile",
                              loading: _vm.loading
                            },
                            on: {
                              click: function($event) {
                                _vm.isShowWarehouseUploadDialog = true
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { dark: "", left: "", small: "" } },
                              [_vm._v("cloud_upload")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("batchUpload")) +
                                "\n        "
                            )
                          ],
                          1
                        )
                      : _c(
                          "v-btn",
                          {
                            attrs: {
                              small: "",
                              color: "primary",
                              title: "importFile",
                              loading: _vm.loading
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { dark: "", left: "", small: "" } },
                              [_vm._v("cloud_upload")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("batchUpload")) +
                                "\n          "
                            ),
                            _c("input", {
                              staticClass: "hideInput",
                              attrs: {
                                type: "file",
                                accept: ".csv,.xls,.xlsx"
                              },
                              on: {
                                click: _vm.clearSelectionCache,
                                change: _vm.uploadFile
                              }
                            })
                          ],
                          1
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md4: "" } },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(tooltip) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, tooltip.on),
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "primary",
                                          title: "importFile",
                                          loading: _vm.loading
                                        },
                                        on: {
                                          click: _vm.batchRetryPendingOrder
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              dark: "",
                                              left: "",
                                              small: ""
                                            }
                                          },
                                          [_vm._v("refresh")]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("batchRetry")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("batchRetryDesc")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.orders,
          callback: function($$v) {
            _vm.orders = $$v
          },
          expression: "orders"
        }
      }),
      _vm._v(" "),
      _vm.isShowDownloadDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("download"),
              rightMethod: _vm.downloadAppleOrders,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.isShowDownloadDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _vm.isWarehouse
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.$t("organizationName"),
                                          items: _vm.organizations,
                                          "item-text": "organizationId",
                                          "item-value": "key",
                                          clearable: "",
                                          chips: "",
                                          small: ""
                                        },
                                        model: {
                                          value:
                                            _vm.selectedDownloadOrganization,
                                          callback: function($$v) {
                                            _vm.selectedDownloadOrganization = $$v
                                          },
                                          expression:
                                            "selectedDownloadOrganization"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "mb-3": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("DatePicker", {
                                    attrs: {
                                      dateString: true,
                                      label: _vm.$t("startDate"),
                                      isShowIcon: false
                                    },
                                    model: {
                                      value: _vm.downloadParams.startDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.downloadParams,
                                          "startDate",
                                          $$v
                                        )
                                      },
                                      expression: "downloadParams.startDate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("DatePicker", {
                                    attrs: {
                                      dateString: true,
                                      label: _vm.$t("endDate"),
                                      isShowIcon: false
                                    },
                                    model: {
                                      value: _vm.downloadParams.endDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.downloadParams,
                                          "endDate",
                                          $$v
                                        )
                                      },
                                      expression: "downloadParams.endDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              371393977
            ),
            model: {
              value: _vm.isShowDownloadDialog,
              callback: function($$v) {
                _vm.isShowDownloadDialog = $$v
              },
              expression: "isShowDownloadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAlreadyExistsOrdersDialog
        ? _c("FormSubmitPopup", {
            attrs: { title: _vm.$t("alreadyExistsOrders"), hideRgtBtn: "" },
            on: {
              popupClose: function($event) {
                _vm.showAlreadyExistsOrdersDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "mb-3": "", "align-center": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-textarea", {
                                    staticClass: "thinBox",
                                    attrs: {
                                      id: "alreadyExistsOrders",
                                      label: _vm.$t("alreadyExistsOrders"),
                                      outline: "",
                                      readonly: ""
                                    },
                                    model: {
                                      value: _vm.alreadyExistsOrders,
                                      callback: function($$v) {
                                        _vm.alreadyExistsOrders = $$v
                                      },
                                      expression: "alreadyExistsOrders"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4118728779
            ),
            model: {
              value: _vm.showAlreadyExistsOrdersDialog,
              callback: function($$v) {
                _vm.showAlreadyExistsOrdersDialog = $$v
              },
              expression: "showAlreadyExistsOrdersDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowWarehouseUploadDialog
        ? _c("FormSubmitPopup", {
            attrs: { title: _vm.$t("batchUpload"), hideRgtBtn: "" },
            on: {
              popupClose: function($event) {
                _vm.isShowWarehouseUploadDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "mb-3": "", "align-center": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: _vm.$t("organizationName"),
                                      items: _vm.organizations,
                                      "item-text": "organizationId",
                                      "item-value": "key"
                                    },
                                    model: {
                                      value: _vm.selectOrganizationUpload,
                                      callback: function($$v) {
                                        _vm.selectOrganizationUpload = $$v
                                      },
                                      expression: "selectOrganizationUpload"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled: !_vm.selectOrganizationUpload,
                                        small: "",
                                        color: "primary",
                                        title: "importFile",
                                        loading: _vm.loading
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            dark: "",
                                            left: "",
                                            small: ""
                                          }
                                        },
                                        [_vm._v("cloud_upload")]
                                      ),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("batchUpload")) +
                                          "\n              "
                                      ),
                                      _c("input", {
                                        staticClass: "hideInput",
                                        attrs: {
                                          type: "file",
                                          accept: ".csv,.xls,.xlsx"
                                        },
                                        on: {
                                          click: _vm.clearSelectionCache,
                                          change: _vm.uploadFile
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3904867276
            ),
            model: {
              value: _vm.isShowWarehouseUploadDialog,
              callback: function($$v) {
                _vm.isShowWarehouseUploadDialog = $$v
              },
              expression: "isShowWarehouseUploadDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a45c542", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a45c542","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppleOrders.vue
// module id = null
// module chunks = 